import { ModelPricing } from 'src/types';
import {
  COMPLEX_DEFAULT_MODELS,
  FAST_DEFAULT_MODELS,
  StandardDefaultModelsWrapper,
} from 'src/constants/payments';

export const MODEL_PRICING_COLUMNS: {
  header: string;
  caption?: string;
  key: string;
}[] = [
  {
    header: 'Model',
    key: 'model',
  },
  {
    header: 'Input price',
    caption: 'per million tokens',
    key: 'input_tokens',
  },
  {
    header: 'Output price',
    caption: 'per million tokens',
    key: 'output_tokens',
  },
  // {
  //   header: 'Price',
  //   caption: 'task',
  //   key: 'price',
  // },
];

export const MODEL_PRICING_DATA_NEW: ModelPricing[] = [
  {
    companyName: 'SuperNinja',
    companyLogo: 'superNinjaMainIcon',
    models: [
      {
        modelName: 'Qwen 3 Coder 480B (Cerebras)',
        modelDescription: 'Default for Ninja Cline VS Studio',
        inputPrice: 3.0,
        outputPrice: 3.0,
        currency: 'USD',
      },
      {
        modelName: 'SuperNinja Standard mode',
        modelDescription: 'Balanced for quality & speed',
        defaultModels: <StandardDefaultModelsWrapper />,
        inputPrice: 1.5,
        outputPrice: 1.5,
        currency: 'USD',
      },
      {
        modelName: 'SuperNinja Complex mode',
        modelDescription: 'Highest quality LLM for complex tasks',
        defaultModels: COMPLEX_DEFAULT_MODELS,
        inputPrice: 4.5,
        outputPrice: 22.5,
        currency: 'USD',
      },
      {
        modelName: 'SuperNinja Fast mode',
        modelDescription: 'Fastest agent in the world',
        defaultModels: FAST_DEFAULT_MODELS,
        inputPrice: 3.75,
        outputPrice: 3.75,
        currency: 'USD',
      },
    ],
  },
  {
    companyName: 'Ninja API access',
    companyLogo: 'ninjaMainIcon',
    models: [
      {
        modelName: 'Turbo 1.0',
        inputPrice: 0.11,
        outputPrice: 0.42,
        currency: 'USD',
      },
      {
        modelName: 'Apex 1.0',
        inputPrice: 0.88,
        outputPrice: 7.0,
        currency: 'USD',
      },
      {
        modelName: 'Reasoning 2.0',
        inputPrice: 0.38,
        outputPrice: 1.53,
        currency: 'USD',
      },
      {
        modelName: 'Deep Research 2.0',
        inputPrice: 1.4,
        outputPrice: 5.6,
        currency: 'USD',
      },
    ],
  },
];
